/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResendActivationRequest as ModelsResendActivationRequest } from '../../models/models/resend-activation-request';
import { SuccessResponse as ModelsSuccessResponse } from '../../models/models/success-response';

export interface ApiV1AuthResendActivationPost$Params {
  
    /**
     * Resend activation request
     */
    body: ModelsResendActivationRequest
}

export function apiV1AuthResendActivationPost(http: HttpClient, rootUrl: string, params: ApiV1AuthResendActivationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
  const rb = new RequestBuilder(rootUrl, apiV1AuthResendActivationPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsSuccessResponse>;
    })
  );
}

apiV1AuthResendActivationPost.PATH = '/api/v1/auth/resend-activation';
